import COLORS from '@/design-system/colors.json';
import { Mutations } from '../mutations/dashboard-mutations';
import { Actions } from '../actions/dashboard-actions';
import { Getters } from '../getters/dashboard-getters';

const initialState = {
  config: {
    gridItemRowHeight: 8,
  },
  // slide 2:
  coordinatorUtilizationChart: {
    // slide2
    type: 'line',
    data: {
      labels: [],
      datasets: [
        {
          label: 'Builds',
          yAxisID: 'rightSide',
          type: 'line',
          lineTension: 0,
          // fill: 'start',
          data: [],
          // backgroundColor: `${COLORS['System/app_primary']}80`,
          borderColor: `${COLORS['System/app_primary']}`,
          fontColor: '#000000',
          borderWidth: 2,
          dataHidden: false,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: `${COLORS['System/app_primary']}`,
          pointHoverBorderColor: `${COLORS['System/app_primary_bg']}`, // '#000000',
        },
        {
          label: 'Cloud active',
          yAxisID: 'leftSide',
          type: 'line',
          lineTension: 0,
          data: [],
          backgroundColor: `${COLORS['Status/status_offline']}80`,
          borderColor: `${COLORS['Status/status_offline']}`,
          fontColor: '#000000',
          borderWidth: 1,
          dataHidden: false,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: `${COLORS['Status/status_offline']}`,
          pointHoverBorderColor: `${COLORS['System/app_primary_bg']}`, // '#000000',
        },
        {
          label: 'On prem active',
          labelNoCloud: 'Active cores',
          yAxisID: 'leftSide',
          type: 'line',
          lineTension: 0,
          fill: 'start',
          data: [],
          backgroundColor: `${COLORS['Text/text_low_old']}80`,
          borderColor: `${COLORS['Text/text_low_old']}`,
          fontColor: '#FFFFFF',
          borderWidth: 1,
          dataHidden: false,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: `${COLORS['Text/text_low_old']}`,
          pointHoverBorderColor: `${COLORS['System/app_primary_bg']}`, // '#000000',
        },
        {
          label: 'Total available',
          yAxisID: 'leftSide',
          type: 'line',
          lineTension: 0,
          fill: 'start',
          data: [],
          backgroundColor: `${COLORS['System/app_grey_22']}`,
          borderColor: `${COLORS['System/app_grey_22']}`,
          fontColor: '#ffffff',
          borderWidth: 1,
          dataHidden: false,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBackgroundColor: `${COLORS['System/app_grey_22']}`,
          pointHoverBorderColor: `${COLORS['System/app_primary_bg']}`, // '#000000',
        },
      ],
    },
  },
  coordinatorUtilizationChart0: [],
  coordinatorUtilizationChart1: [],
  coordinatorUtilizationChart2: [],
  coordinatorUtilizationChart3: [],
  coordinatorUtilizationChart3stacked: [],
  coordinatorUtilizationChartFilters: {
    timeRangeSelected: 24,
    stackedChart: false,
    loadingData: false,
  },
  // slide 3:
  dailyCoresUsageChart: {
    type: 'line',
    data: {
      labels: [],
      datasets: [
        {
          label: 'Max. Daily Cores',
          type: 'line',
          lineTension: 0,
          backgroundColor: '#ffffff',
          legendBackground: `${COLORS['System/app_grey_22']}`,
          borderColor: `${COLORS['System/app_grey_22']}80`,
          data: [],
          fontColor: '#ffffff',
          borderWidth: 2,
          dataHidden: false,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBorderColor: '#000000',
        },
        {
          label: 'Avg. Daily Cores',
          type: 'bar',
          barThickness: 70,
          maxBarThickness: 80,
          data: [],
          backgroundColor: `${COLORS['System/app_primary']}`,
          legendBackground: `${COLORS['System/app_primary']}`,
          borderColor: `${COLORS['System/app_primary']}80`,
          fontColor: `${COLORS['System/app_grey_22']}`,
          borderWidth: 1,
          dataHidden: false,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointHoverBorderColor: '#000000',
        },
      ],
    },
  },
  dailyCoresUsageChartFilters: {
    filterDateSelected: 'last7days',
    loadingData: false,
    timeRange: { to: '', from: '' },
  },
  // ex
  telemetryActiveInfo: {},
  slide2TestData: {
    Builds: {
      1617433200: 20,
      1617436800: 30,
      1617440400: 20,
      1617444000: 20,
      1617447600: 60,
      1617451200: 30,
    },
    Cores: {
      1617433200: {
        Active: {
          Cloud: 50,
          Floating: 75,
          Named: 100,
        },
        Total: {
          Cloud: 200,
          Floating: 150,
          Named: 200,
        },
      },
      1617436800: {
        Active: {
          Cloud: 190,
          Floating: 140,
          Named: 200,
        },
        Total: {
          Cloud: 200,
          Floating: 150,
          Named: 200,
        },
      },
      1617440400: {
        Active: {
          Cloud: 150,
          Floating: 50,
          Named: 150,
        },
        Total: {
          Cloud: 200,
          Floating: 150,
          Named: 200,
        },
      },
      1617444000: {
        Active: {
          Cloud: 100,
          Floating: 100,
          Named: 50,
        },
        Total: {
          Cloud: 200,
          Floating: 150,
          Named: 200,
        },
      },
      1617447600: {
        Active: {
          Cloud: 90,
          Floating: 140,
          Named: 60,
        },
        Total: {
          Cloud: 100,
          Floating: 150,
          Named: 200,
        },
      },
      1617451200: {
        Active: {
          Cloud: 50,
          Floating: 90,
          Named: 60,
        },
        Total: {
          Cloud: 100,
          Floating: 150,
          Named: 200,
        },
      },
    },
  },
  slide3TestData: {
    0: {
      AVG: 416.49657407407409,
      MAX: 775,
      Time: '2020-11-11 00:00:00',
    },
    1: {
      AVG: 309.63668981481482,
      MAX: 560,
      Time: '2020-11-12 00:00:00',
    },
    2: {
      AVG: 382.48221064814817,
      MAX: 450,
      Time: '2020-11-13 00:00:00',
    },
    3: {
      AVG: 557.79608796296293,
      MAX: 1055,
      Time: '2020-11-14 00:00:00',
    },
    4: {
      AVG: 401.3760300925926,
      MAX: 576,
      Time: '2020-11-15 00:00:00',
    },
    5: {
      AVG: 431.20172453703702,
      MAX: 989,
      Time: '2020-11-16 00:00:00',
    },
    6: {
      AVG: 435.00202546296299,
      MAX: 677,
      Time: '2020-11-17 00:00:00',
    },
    7: {
      AVG: 394.41160879629632,
      MAX: 499,
      Time: '2020-11-18 00:00:00',
    },
  },
  // coordinatorUtilizationDataset: false,
  slide4TestData: {
    DistinctBuilds: {
      'Build Title: 121': 121,
      'Build Title: 122': 122,
    },
    DistinctInitiators: [
      {
        Name: '5640BA20E4C3E6A95B30FEC064F0FDA2',
        ID: 'LWO1-LHP-A05501',
      },
      {
        Name: 'yftah',
        ID: '1',
      },
      {
        Name: 'yair',
        ID: '2',
      },
      {
        Name: 'yehuda',
        ID: '3',
      },

      // {"yair": 39},
      // {"yftah": 657},
      // {"yehuda": 803}
    ],
    UtilisedFeatures: {
      BuildAvoidance: {
        Count: 123,
        ID: 6,
      },
      'C#': {
        Count: 114,
        ID: 2,
      },
      'C++': {
        Count: 116,
        ID: 1,
      },
    },
    MissingFeatures: {
      BuildAvoidance: {
        Count: 92,
        ID: 6,
      },
      'C#': {
        Count: 100,
        ID: 2,
      },
    },
  },
  slide5TestData: {
    // unused, i generate data instead.
    Builds: {
      1: {
        Caption: 'PS Build',
        Duration: 100,
        Initiator: 'yair',
        BuildID: '123',
      },
      2: {
        Caption: 'C++',
        Duration: 200,
        Initiator: 'yftah',
        BuildID: '1234',
      },
      3: {
        Caption: 'PS Build',
        Duration: 150,
        Initiator: 'yehuda',
        BuildID: '333',
      },
      4: {
        Caption: 'C++',
        Duration: 250,
        Initiator: 'yair',
        BuildID: '666',
      },
      5: {
        Caption: 'C# Build',
        Duration: 100,
        Initiator: 'yair',
        BuildID: '777',
      },
      6: {
        Caption: 'Borderlands',
        Duration: 200,
        Initiator: 'yftah',
        BuildID: '5552',
      },
      7: {
        Caption: 'Borderlands',
        Duration: 150,
        Initiator: 'yehuda',
        BuildID: '5553',
      },
      8: {
        Caption: 'Borderlands',
        Duration: 250,
        Initiator: 'yair',
        BuildID: '5554',
      },
      9: {
        Caption: 'Borderlands',
        Duration: 150,
        Initiator: 'yehuda',
        BuildID: '5555',
      },
      10: {
        Caption: 'Vuvuzela',
        Duration: 250,
        Initiator: 'yair',
        BuildID: '77765',
      },
    },
  },
  slide2Dataset: false,
  workloadUtilizationDataset: false,
  workloadUtilizationDatasetDrilldown: false,
  workloadsByDataset: false,
  workloadsByDatasetDrilldownBuilds: false,
  workloadsByDatasetDrilldownHelpers: false,
  slide4Filters: {
    featured: ['All'],
    filterDateSelected: 'today',
    filterBar: false,
    features_filt: [],
    features_filt_options: [],
    agents_filt: [],
    agents_filt_options: [],
    build_caption_filt: [],
    build_caption_filt_options: [],
    timeRange: { to: '', from: '' },
    timeRangeForList: { to: '', from: '' },
    // drilldown only:
    feature: null,
    isUtilised: true,
  },
  slide5Filters: {
    filterBar: false,
    workloadChartType: 'Duration',
    filterDateSelected: 'today',
    timeRange: { to: '', from: '' },
    filterCount: 'All',
    // builds drilldown:
    feature: null,
    agent_names: [],
    build_captions: [],
    build_ids: [],
  },
  agentsUtilizationChart: {},
  agentsUtilizationChartFilters: {
    filterBar: false,
    filterDateSelected: 'lastday',
    loadingData: false,
    sortType: 'Avg. Cores', // types: 'Avg. Cores' & 'Duration'
    timeRange: { to: '', from: '' },
    timeRangeForList: { to: '', from: '' },
    agent_names: [],
    captionList: [],
    build_captions: [],
    groupsList: [],
    build_groups: [],
    agent_names_options: [],
    agent_names_roles: { initiator: true, helper: true },
  },
  agentsUtilizationChartExampleDataset: {
    Agents: {
      // "": {
      //   "AvailableTime": 0,
      //   "AvgCores": 0,
      //   "DurationAsHelper": 34575038,
      //   "DurationAsInitiator": 32960073,
      //   "NumberOfCores": 0,
      //   "TotalTime": 0
      // },
      // //yftah real
      // "LAPTOP-K1KIBG0R": {
      //   "AvailableTime": 0,
      //   "AvgCores": 0,
      //   "DurationAsHelper": 0,
      //   "DurationAsInitiator": 14,
      //   "NumberOfCores": 0,
      //   "TotalTime": 0
      // },
      // random stuff to try makebelieve
      'Agent 1': {
        AvailableTime: 40000,
        AvgCores: 4,
        DurationAsHelper: 20000,
        DurationAsInitiator: 30000,
        NumberOfCores: 8,
        TotalTime: 70600,
      },
      'Agent 2': {
        AvailableTime: 4000,
        AvgCores: 5,
        DurationAsHelper: 2000,
        DurationAsInitiator: 2000,
        NumberOfCores: 8,
        TotalTime: 60600,
      },
      'Agent 3': {
        AvailableTime: 2000,
        AvgCores: 7,
        DurationAsHelper: 0,
        DurationAsInitiator: 2000,
        NumberOfCores: 8,
        TotalTime: 40300,
      },
      'Agent 4': {
        AvailableTime: 5000,
        AvgCores: 2,
        DurationAsHelper: 4000,
        DurationAsInitiator: 0,
        NumberOfCores: 16,
        TotalTime: 20300,
      },
      'Agent 5': {
        AvailableTime: 5000,
        AvgCores: 11,
        DurationAsHelper: 25000,
        DurationAsInitiator: 25000,
        NumberOfCores: 16,
        TotalTime: 60300,
      },
    },
  },
};

export default {
  namespaced: true, // set to true in case we wish to use multiple modules at the same time
  state: initialState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};
